module.exports = __webpack_public_path__ + "media/images/charity-banner-f933a1ca4ecb6ab271e6e0394fcab32c.png";